export enum TagTitleOption {
  MAIN = 'main',
  SECONDARY = 'secondary',
}
